module.exports = __webpack_public_path__ + "static/media/message_sound.55342729.mp3";